export default "__VITE_PUBLIC_ASSET__37909e9f__"